export const IS_SMART_STICKERS_AVAILABLE = {
  EG: false,
  SA: false
};
